import { CSSProperties } from 'react';
import Modal from 'react-bootstrap/Modal';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import Images from '../../Images';

interface Props {
  isShow: boolean;
  onHide: () => void;
  messageText: string;
  titleText: string;
  onOkay: () => void;
  dialogClass?: string;
  contentClass?: string;
  titleClass?: string;
}

function handleGeneralErroMessageOnOkay(onHide: () => void, onOkay: () => void) {
  onHide();
  if (onOkay) {
    onOkay();
  }
}

const messageContainerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
};

const imageStyle: CSSProperties = {
  height: '8rem',
  width: '8rem',
  margin: '1.4rem',
};

export const GeneralErrorMessage = ({
  isShow,
  onHide,
  messageText,
  titleText,
  onOkay,
  titleClass,
  dialogClass,
  contentClass,
}: Props): JSX.Element => (
  <Modal
    show={isShow}
    onHide={onHide}
    dialogClassName={`ModalDialog responsiveModalWidth ${dialogClass ?? ''}`}
    contentClassName={contentClass ?? ''}
  >
    <Modal.Header closeButton>
      <div className={`generalDialogTitle ${titleClass ?? ''}`}>{titleText || `There's a Problem`}</div>
    </Modal.Header>
    <Modal.Body>
      <div style={messageContainerStyle}>
        <div>
          <img style={imageStyle} src={Images.backpackPatch} alt='Broken backpack indicating error' />
        </div>
        {messageText && (
          <span className='ModalDialogText generalErrorMessage' dangerouslySetInnerHTML={{ __html: messageText }} />
        )}
      </div>
      <div style={{ textAlign: 'center', padding: '2em', verticalAlign: 'middle' }}>
        <PrimaryButton onClick={() => handleGeneralErroMessageOnOkay(onHide, onOkay)}>Okay</PrimaryButton>
      </div>
    </Modal.Body>
  </Modal>
);
